// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"ou-z","giftOrPromoSelector":"pu-z","disabled":"qu-z","subTitle":"ru-z","selectShipAddressMessage":"su-z","changePayment":"tu-z"};